/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterslatin
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Latin" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersLatin ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersLatin extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Latin', [
            {
                character: 'Ā',
                title: t('bi')
            },
            {
                character: 'ā',
                title: t('bj')
            },
            {
                character: 'Ă',
                title: t('bk')
            },
            {
                character: 'ă',
                title: t('bl')
            },
            {
                character: 'Ą',
                title: t('bm')
            },
            {
                character: 'ą',
                title: t('bn')
            },
            {
                character: 'Ć',
                title: t('bo')
            },
            {
                character: 'ć',
                title: t('bp')
            },
            {
                character: 'Ĉ',
                title: t('bq')
            },
            {
                character: 'ĉ',
                title: t('br')
            },
            {
                character: 'Ċ',
                title: t('bs')
            },
            {
                character: 'ċ',
                title: t('bt')
            },
            {
                character: 'Č',
                title: t('bu')
            },
            {
                character: 'č',
                title: t('bv')
            },
            {
                character: 'Ď',
                title: t('bw')
            },
            {
                character: 'ď',
                title: t('bx')
            },
            {
                character: 'Đ',
                title: t('by')
            },
            {
                character: 'đ',
                title: t('bz')
            },
            {
                character: 'Ē',
                title: t('ca')
            },
            {
                character: 'ē',
                title: t('cb')
            },
            {
                character: 'Ĕ',
                title: t('cc')
            },
            {
                character: 'ĕ',
                title: t('cd')
            },
            {
                character: 'Ė',
                title: t('ce')
            },
            {
                character: 'ė',
                title: t('cf')
            },
            {
                character: 'Ę',
                title: t('cg')
            },
            {
                character: 'ę',
                title: t('ch')
            },
            {
                character: 'Ě',
                title: t('ci')
            },
            {
                character: 'ě',
                title: t('cj')
            },
            {
                character: 'Ĝ',
                title: t('ck')
            },
            {
                character: 'ĝ',
                title: t('cl')
            },
            {
                character: 'Ğ',
                title: t('cm')
            },
            {
                character: 'ğ',
                title: t('cn')
            },
            {
                character: 'Ġ',
                title: t('co')
            },
            {
                character: 'ġ',
                title: t('cp')
            },
            {
                character: 'Ģ',
                title: t('cq')
            },
            {
                character: 'ģ',
                title: t('cr')
            },
            {
                character: 'Ĥ',
                title: t('cs')
            },
            {
                character: 'ĥ',
                title: t('ct')
            },
            {
                character: 'Ħ',
                title: t('cu')
            },
            {
                character: 'ħ',
                title: t('cv')
            },
            {
                character: 'Ĩ',
                title: t('cw')
            },
            {
                character: 'ĩ',
                title: t('cx')
            },
            {
                character: 'Ī',
                title: t('cy')
            },
            {
                character: 'ī',
                title: t('cz')
            },
            {
                character: 'Ĭ',
                title: t('da')
            },
            {
                character: 'ĭ',
                title: t('db')
            },
            {
                character: 'Į',
                title: t('dc')
            },
            {
                character: 'į',
                title: t('dd')
            },
            {
                character: 'İ',
                title: t('de')
            },
            {
                character: 'ı',
                title: t('df')
            },
            {
                character: 'Ĳ',
                title: t('dg')
            },
            {
                character: 'ĳ',
                title: t('dh')
            },
            {
                character: 'Ĵ',
                title: t('di')
            },
            {
                character: 'ĵ',
                title: t('dj')
            },
            {
                character: 'Ķ',
                title: t('dk')
            },
            {
                character: 'ķ',
                title: t('dl')
            },
            {
                character: 'ĸ',
                title: t('dm')
            },
            {
                character: 'Ĺ',
                title: t('dn')
            },
            {
                character: 'ĺ',
                title: t('do')
            },
            {
                character: 'Ļ',
                title: t('dp')
            },
            {
                character: 'ļ',
                title: t('dq')
            },
            {
                character: 'Ľ',
                title: t('dr')
            },
            {
                character: 'ľ',
                title: t('ds')
            },
            {
                character: 'Ŀ',
                title: t('dt')
            },
            {
                character: 'ŀ',
                title: t('du')
            },
            {
                character: 'Ł',
                title: t('dv')
            },
            {
                character: 'ł',
                title: t('dw')
            },
            {
                character: 'Ń',
                title: t('dx')
            },
            {
                character: 'ń',
                title: t('dy')
            },
            {
                character: 'Ņ',
                title: t('dz')
            },
            {
                character: 'ņ',
                title: t('ea')
            },
            {
                character: 'Ň',
                title: t('eb')
            },
            {
                character: 'ň',
                title: t('ec')
            },
            {
                character: 'ŉ',
                title: t('ed')
            },
            {
                character: 'Ŋ',
                title: t('ee')
            },
            {
                character: 'ŋ',
                title: t('ef')
            },
            {
                character: 'Ō',
                title: t('eg')
            },
            {
                character: 'ō',
                title: t('eh')
            },
            {
                character: 'Ŏ',
                title: t('ei')
            },
            {
                character: 'ŏ',
                title: t('ej')
            },
            {
                character: 'Ő',
                title: t('ek')
            },
            {
                character: 'ő',
                title: t('el')
            },
            {
                character: 'Œ',
                title: t('em')
            },
            {
                character: 'œ',
                title: t('en')
            },
            {
                character: 'Ŕ',
                title: t('eo')
            },
            {
                character: 'ŕ',
                title: t('ep')
            },
            {
                character: 'Ŗ',
                title: t('eq')
            },
            {
                character: 'ŗ',
                title: t('er')
            },
            {
                character: 'Ř',
                title: t('es')
            },
            {
                character: 'ř',
                title: t('et')
            },
            {
                character: 'Ś',
                title: t('eu')
            },
            {
                character: 'ś',
                title: t('ev')
            },
            {
                character: 'Ŝ',
                title: t('ew')
            },
            {
                character: 'ŝ',
                title: t('ex')
            },
            {
                character: 'Ş',
                title: t('ey')
            },
            {
                character: 'ş',
                title: t('ez')
            },
            {
                character: 'Š',
                title: t('fa')
            },
            {
                character: 'š',
                title: t('fb')
            },
            {
                character: 'Ţ',
                title: t('fc')
            },
            {
                character: 'ţ',
                title: t('fd')
            },
            {
                character: 'Ť',
                title: t('fe')
            },
            {
                character: 'ť',
                title: t('ff')
            },
            {
                character: 'Ŧ',
                title: t('fg')
            },
            {
                character: 'ŧ',
                title: t('fh')
            },
            {
                character: 'Ũ',
                title: t('fi')
            },
            {
                character: 'ũ',
                title: t('fj')
            },
            {
                character: 'Ū',
                title: t('fk')
            },
            {
                character: 'ū',
                title: t('fl')
            },
            {
                character: 'Ŭ',
                title: t('fm')
            },
            {
                character: 'ŭ',
                title: t('fn')
            },
            {
                character: 'Ů',
                title: t('fo')
            },
            {
                character: 'ů',
                title: t('fp')
            },
            {
                character: 'Ű',
                title: t('fq')
            },
            {
                character: 'ű',
                title: t('fr')
            },
            {
                character: 'Ų',
                title: t('fs')
            },
            {
                character: 'ų',
                title: t('ft')
            },
            {
                character: 'Ŵ',
                title: t('fu')
            },
            {
                character: 'ŵ',
                title: t('fv')
            },
            {
                character: 'Ŷ',
                title: t('fw')
            },
            {
                character: 'ŷ',
                title: t('fx')
            },
            {
                character: 'Ÿ',
                title: t('fy')
            },
            {
                character: 'Ź',
                title: t('fz')
            },
            {
                character: 'ź',
                title: t('ga')
            },
            {
                character: 'Ż',
                title: t('gb')
            },
            {
                character: 'ż',
                title: t('gc')
            },
            {
                character: 'Ž',
                title: t('gd')
            },
            {
                character: 'ž',
                title: t('ge')
            },
            {
                character: 'ſ',
                title: t('gf')
            }
        ]);
    }
}